import api from './api'

export interface WahaInstance {
  id: string
  instanceName: string
  evoInstanceId: string
  status: string
  phoneNumber?: string
  profileName?: string
  createdAt: string
  updatedAt: string
}

export interface WahaQRResponse {
  instanceId?: string
  instanceName?: string
  qr?: {
    base64?: string
    url?: string
    mimetype?: string
    data?: string
  }
  message?: string
  status?: string
}

export interface WahaStatusResponse {
  instanceId: string
  instanceName: string
  status: string
  wahaStatus: string
  phoneNumber?: string
  profileName?: string
}

export async function listWahaInstances() {
  const { data } = await api.get<{ success: boolean; data: WahaInstance[] }>('/waha/instances')
  return data.data
}

export async function createWahaInstance(payload: { instanceName?: string }) {
  const { data } = await api.post<{ success: boolean; data: WahaInstance }>('/waha/instances', payload)
  return data.data
}

export async function getWahaQRCode(instanceId: string) {
  const { data } = await api.get<{ success: boolean; data: any }>(`/waha/instances/${instanceId}/qr`)
  return data.data as WahaQRResponse
}

export async function getWahaInstanceStatus(instanceId: string) {
  const { data } = await api.get<{ success: boolean; data: WahaStatusResponse }>(`/waha/instances/${instanceId}/status`)
  return data.data
}

export async function deleteWahaInstance(instanceId: string) {
  const { data } = await api.delete<{ success: boolean; message: string }>(`/waha/instances/${instanceId}`)
  return data
}

export async function startWahaInstance(instanceId: string) {
  const { data } = await api.post<{ success: boolean; data: WahaInstance }>(`/waha/instances/${instanceId}/start`)
  return data.data
}

export async function stopWahaInstance(instanceId: string) {
  const { data } = await api.post<{ success: boolean; data: WahaInstance }>(`/waha/instances/${instanceId}/stop`)
  return data.data
}

export async function restartWahaInstance(instanceId: string) {
  const { data } = await api.post<{ success: boolean; data: WahaInstance }>(`/waha/instances/${instanceId}/restart`)
  return data.data
}

export async function logoutWahaInstance(instanceId: string) {
  const { data } = await api.post<{ success: boolean; data: WahaInstance }>(`/waha/instances/${instanceId}/logout`)
  return data.data
}
